import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    Timestamp,
    where,
    writeBatch,
    updateDoc
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';

function Livebookings() {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [bookings, setbookings] = useState([]);
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [searchText, setsearchText] = useState("");

    const [bookingId, setbookingId] = useState("");

    const [requestType, setrequestType] = useState("Exchange Room");
    const [requestNote, setrequestNote] = useState("");

    const [roomUsed, setroomUsed] = useState("No");

    // Reservation Note
    const [reservationNote, setreservationNote] = useState("");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {

                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)

                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData1()
    }, []);

    useEffect(() => {

        if (searchText === '') {
            fetchData1()
        } else {

            const filteredData = bookings.filter((item) =>
                item.data.customers.custname.toUpperCase().includes(searchText.toUpperCase())
            );

            setbookings(filteredData);
            setCurrentPage(1);
        }

    }, [searchText]);

    const fetchData1 = async () => {

        try {

            const q = query(
                collection(db, 'bookings'),
                orderBy("createdAt", "asc"),
                where('status', '==', 'Booked')
            )

            onSnapshot(q, (querySnapshot) => {

                setbookings(
                    querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        data: doc.data()
                    }))
                );

                setCurrentPage(1);

            });

        } catch (error) {

            console.log(error.message);

            Toast.fire({
                icon: "error",
                title: error.message
            });

        }

    }

    const storeRequest = async () => {

        if (!bookingId || !requestType || !requestNote) {

            Toast.fire({
                icon: "error",
                title: 'Request Note or Request Type should not be blank'
            });

            return
        }

        await addDoc(collection(db, 'approvals'), {

            bookingid: bookingId,
            requestType: requestType,
            requestNote: requestNote,
            status: 'Pending',
            rejectedreason: '',
            updatedat: "",
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),

        });

        setrequestNote("");

        Toast.fire({
            icon: "success",
            title: 'Approval Request send to the GM'
        });

    }

    // ================= ADD RESERVATION NOTE =================

    const addReservationNote = async () => {

        try {

            if (!bookingId || !reservationNote) {

                Toast.fire({
                    icon: "error",
                    title: "Please enter reservation note"
                });

                return;
            }

            const bookingRef = doc(db, "bookings", bookingId);

            await updateDoc(bookingRef, {
                reservationNote: reservationNote,
                reservationNoteUpdatedAt: Timestamp.now(),
                reservationNoteBy: username
            });

            // Optional Logs
            await addDoc(collection(db, 'logs'), {
                bookingid: bookingId,
                note: reservationNote,
                uid: userData.uid,
                username: username,
                type: 'Reservation Note Added',
                createdAt: Timestamp.now(),
            });

            setreservationNote("");

            Toast.fire({
                icon: "success",
                title: "Reservation note added successfully"
            });

        } catch (error) {

            console.log(error);

            Toast.fire({
                icon: "error",
                title: error.message
            });

        }

    }

    // ================= CANCEL BOOKING =================

    const cancleBooking = async () => {

        const bookingRef = doc(db, "bookings", bookingId);

        const batch = writeBatch(db);

        batch.update(bookingRef, {
            status: "Canceled"
        });

        const checkinDetailsQuery = query(
            collection(db, 'checkindetails'),
            where('bookingid', '==', bookingId)
        );

        const checkinDetailsSnapshot = await getDocs(checkinDetailsQuery);

        checkinDetailsSnapshot.docs.forEach(item => {

            const checkinRef = doc(db, "checkindetails", item.id);

            batch.update(checkinRef, {
                status: "Canceled"
            });

        });

        const payHistoryQuery = query(
            collection(db, 'payhistory'),
            where('bookingid', '==', bookingId)
        );

        const payHistorySnapshot = await getDocs(payHistoryQuery);

        payHistorySnapshot.docs.forEach(item => {

            const payHistoryRef = doc(db, "payhistory", item.id);

            batch.update(payHistoryRef, {
                status: "Canceled"
            });

        });

        const bookingSnap = await getDoc(bookingRef);

        const rooms = bookingSnap.data().rooms;

        rooms.forEach(room => {

            const roomRef = doc(db, "roomdetails", room.roomid);

            const status = roomUsed === 'Yes'
                ? 'Cleaning'
                : 'Available';

            batch.update(roomRef, {
                status
            });

        });

        await addDoc(collection(db, 'logs'), {

            bookingid: bookingId,
            customerId: bookingSnap.data().customerId,
            customers: bookingSnap.data().customers,
            rooms: rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Booking Cancellation',

        });

        await batch.commit();

        Toast.fire({
            icon: "success",
            title: 'Room Successfully Canceled'
        });

    }

    // Pagination calculations

    const indexOfLastRow = currentPage * rowsPerPage;

    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(bookings.length / rowsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages)
            setCurrentPage(prev => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1)
            setCurrentPage(prev => prev - 1);
    };

    return (
        <div>

            <Menu />

            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>

                <section className="content">

                    <div className="container-fluid">

                        <button
                            className="btn btn-secondary"
                            style={{ textTransform: "uppercase" }}
                        >
                            || Live Bookings ||
                        </button>

                        <div className="card card-primary card-outline mt-2">

                            <div className="p-1">

                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4'
                                    placeholder='Type here......'
                                />

                            </div>

                            <div className="card-body table-responsive p-0">

                                <table className="table table-bordered table-hover table-striped table-head-fixed">

                                    <thead>

                                        <tr>

                                            <th>Sr No</th>
                                            <th>Action</th>
                                            <th>Customer Name</th>
                                            <th>Mobile</th>
                                            <th>Checkin Date</th>
                                            <th>Checkout Date</th>
                                            <th>Rooms</th>
                                            <th>Plans</th>
                                            <th>Adults</th>
                                            <th style={{ textAlign: "right" }}>Total</th>
                                            <th style={{ textAlign: "right" }}>Paid</th>
                                            <th style={{ textAlign: "right" }}>Remaining</th>
                                            <th> Note</th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {
                                            currentRows.map((item, index) =>

                                                <tr key={item.id}>

                                                    <td width="80">
                                                        {indexOfFirstRow + index + 1}
                                                    </td>

                                                    <td>

                                                        {/* Approval */}
                                                        <a
                                                            href='#0'
                                                            onClick={() => setbookingId(item.id)}
                                                            className="btn btn-sm btn-success"
                                                            data-toggle="modal"
                                                            data-target="#approvalModal"
                                                        >
                                                            <i className="fa fa-plus"></i>
                                                        </a>

                                                        &nbsp;

                                                        {/* View */}
                                                        <a
                                                            href={'view-details/' + item.id}
                                                            className='btn btn-info btn-sm'
                                                        >
                                                            <i className="fa fa-eye"></i>
                                                        </a>

                                                        &nbsp;

                                                        {/* Add Note */}
                                                        <a
                                                            href="#0"
                                                            className='btn btn-warning btn-sm'
                                                            onClick={() => {
                                                                setbookingId(item.id);
                                                                setreservationNote(item.data.reservationNote || "");
                                                            }}
                                                            data-toggle="modal"
                                                            data-target="#reservationNoteModal"
                                                        >
                                                            <i className="fa fa-sticky-note"></i>
                                                        </a>

                                                        &nbsp;

                                                        {
                                                            item.data.approval1 === 'Yes' &&
                                                            <a
                                                                className="btn btn-sm bg-teal"
                                                                href={'view-details/' + item.id}
                                                            >
                                                                <i className="fa fa-exchange"></i>
                                                            </a>
                                                        }

                                                        {
                                                            item.data.approval2 === 'Yes' &&
                                                            <a
                                                                className="btn btn-sm bg-red"
                                                                onClick={() => setbookingId(item.id)}
                                                                data-toggle="modal"
                                                                data-target="#cancleModal"
                                                                href="#0"
                                                            >
                                                                <i className="fa fa-close"></i>
                                                            </a>
                                                        }

                                                    </td>

                                                    <td style={{ textTransform: "capitalize" }}>
                                                        {item.data.customers.custname}
                                                    </td>

                                                    <td>
                                                        {item.data.customers.mobile}
                                                    </td>

                                                    <td>
                                                        {moment(item.data.checkindate).format('DD/MM/YYYY')}
                                                    </td>

                                                    <td>
                                                        {moment(item.data.checkoutdate).format('DD/MM/YYYY')}
                                                    </td>

                                                    <td>

                                                        <div className='row'>

                                                            {
                                                                item.data.rooms.map((item1, idx) =>

                                                                    <span key={idx}>
                                                                        {item1.roomname} &nbsp;
                                                                    </span>

                                                                )
                                                            }

                                                        </div>

                                                    </td>

                                                    <td>

                                                        <div className='row'>

                                                            {
                                                                item.data.rooms.map((item1, idx) =>

                                                                    <span key={idx}>
                                                                        {item1.planid} &nbsp;
                                                                    </span>

                                                                )
                                                            }

                                                        </div>

                                                    </td>

                                                    <td>
                                                        {item.data.adults} Persons
                                                    </td>



                                                    <td style={{ textAlign: "right" }}>
                                                        {item.data.totalamount.toFixed(2)}
                                                    </td>

                                                    <td style={{ textAlign: "right" }}>
                                                        {item.data.advance.toFixed(2)}
                                                    </td>

                                                    <td style={{ textAlign: "right" }}>
                                                        {item.data.remaining.toFixed(2)}
                                                    </td>

                                                    <td>
                                                        {
                                                            item.data.reservationNote
                                                                ? item.data.reservationNote
                                                                : ""
                                                        }
                                                    </td>
                                                </tr>

                                            )
                                        }

                                    </tbody>

                                </table>

                            </div>

                            {/* Pagination */}

                            <div className="card-footer d-flex justify-content-center">

                                <nav>

                                    <ul className="pagination pagination-sm">

                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={handlePrev}>
                                                Previous
                                            </button>
                                        </li>

                                        {
                                            Array.from(
                                                { length: totalPages },
                                                (_, i) => i + 1
                                            ).map((page) => (

                                                <li
                                                    key={page}
                                                    className={`page-item ${currentPage === page ? 'active' : ''}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>

                                            ))
                                        }

                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={handleNext}>
                                                Next
                                            </button>
                                        </li>

                                    </ul>

                                </nav>

                            </div>

                        </div>

                    </div>

                </section>

            </div>

            {/* ================= APPROVAL MODAL ================= */}

            <div className="modal fade" id="approvalModal">

                <div className="modal-dialog modal-xl">

                    <div className="modal-content">

                        <div className="modal-header">

                            <h5 className="modal-title">
                                Send Approval Request to GM
                            </h5>

                            <button type="button" className="close" data-dismiss="modal">
                                <span>×</span>
                            </button>

                        </div>

                        <div className="modal-body">

                            <div className='row'>

                                <div className='col-sm-4'>

                                    <select
                                        className='form-control'
                                        value={requestType}
                                        onChange={(e) => setrequestType(e.target.value)}
                                    >
                                        <option value="Exchange Room">Exchange Room</option>
                                        <option value="Cancle Booking">Cancle Booking</option>
                                        <option value="Extra Service Cancle">Extra Service Cancle</option>
                                    </select>

                                </div>

                                <div className='col-sm-8'>

                                    <textarea
                                        className='form-control'
                                        value={requestNote}
                                        onChange={(e) => setrequestNote(e.target.value)}
                                    ></textarea>

                                </div>

                            </div>

                        </div>

                        <div className="modal-footer">

                            <button
                                type="button"
                                data-dismiss="modal"
                                className="btn btn-success"
                                onClick={storeRequest}
                            >
                                Send Request
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>

            </div>

            {/* ================= RESERVATION NOTE MODAL ================= */}

            <div className="modal fade" id="reservationNoteModal">

                <div className="modal-dialog modal-lg">

                    <div className="modal-content">

                        <div className="modal-header">

                            <h5 className="modal-title">
                                Add Reservation Note
                            </h5>

                            <button type="button" className="close" data-dismiss="modal">
                                <span>×</span>
                            </button>

                        </div>

                        <div className="modal-body">

                            <div className='row'>

                                <div className='col-sm-12'>

                                    <label>Reservation Note</label>

                                    <textarea
                                        className='form-control'
                                        rows={5}
                                        value={reservationNote}
                                        onChange={(e) => setreservationNote(e.target.value)}
                                        placeholder='Enter reservation note here...'
                                    ></textarea>

                                </div>

                            </div>

                        </div>

                        <div className="modal-footer">

                            <button
                                type="button"
                                data-dismiss="modal"
                                className="btn btn-success"
                                onClick={addReservationNote}
                            >
                                Save Note
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>

            </div>

            {/* ================= CANCEL MODAL ================= */}

            <div className="modal fade" id="cancleModal">

                <div className="modal-dialog modal-md">

                    <div className="modal-content">

                        <div className="modal-header">

                            <h5 className="modal-title">
                                Are u sure to Cancle Booking
                            </h5>

                            <button type="button" className="close" data-dismiss="modal">
                                <span>×</span>
                            </button>

                        </div>

                        <div className="modal-body">

                            <div className='row'>

                                <div className='col-sm-4'>

                                    <label>Rooms Durty</label>

                                    <select
                                        className='form-control'
                                        value={roomUsed}
                                        onChange={(e) => setroomUsed(e.target.value)}
                                    >
                                        <option value="No">No</option>
                                        <option value="Yes">Yes</option>
                                    </select>

                                </div>

                            </div>

                        </div>

                        <div className="modal-footer">

                            <button
                                type="button"
                                data-dismiss="modal"
                                className="btn btn-success"
                                onClick={cancleBooking}
                            >
                                YES
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                No
                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default Livebookings;